var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49996 8.20333C6.26698 8.20333 6.03402 8.11437 5.85639 7.93683L0.266684 2.34707C-0.0888946 1.99149 -0.0888946 1.41498 0.266684 1.05954C0.622118 0.70411 1.19851 0.70411 1.55412 1.05954L6.49996 6.00568L11.4458 1.05972C11.8014 0.704283 12.3778 0.704283 12.7332 1.05972C13.0889 1.41515 13.0889 1.99166 12.7332 2.34724L7.14354 7.937C6.96582 8.11458 6.73286 8.20333 6.49996 8.20333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/DropDown.529c024c0649b9817810e15e366c8b13.svg";
export { ForwardRef as ReactComponent };